export default __webpack_public_path__ + "audios/c9e53d6b4ff73beb1874af828c095564.mp3";